var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCourses(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1303_94681)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M68.9766 57.6561H66.864C67.1349 57.1279 67.2891 56.5303 67.2891 55.8969L67.2877 19.3353C67.2877 17.203 65.5528 15.4681 63.4205 15.4681H57.7266V14.1799C57.7266 13.1642 56.9002 12.3378 55.8844 12.3378H54.1388V7.04534C54.1388 6.45063 53.8495 5.88968 53.3652 5.54459C52.8808 5.19963 52.2561 5.10963 51.6939 5.30412L48.3718 6.45288C47.8214 6.64329 47.5294 7.24376 47.7197 7.7943C47.9101 8.34471 48.5101 8.63735 49.0611 8.44638L52.0293 7.41996V32.7858L37.0547 37.9643V12.5985L44.8083 9.91718C45.3589 9.72677 45.6507 9.1263 45.4604 8.57576C45.27 8.02535 44.6701 7.73299 44.119 7.92368L36 10.7313L20.3061 5.30412C19.7439 5.10949 19.1192 5.19963 18.6348 5.54459C18.1505 5.88968 17.8612 6.45063 17.8612 7.04534V12.3376H16.1156C15.0997 12.3376 14.2734 13.1641 14.2734 14.1798V15.4693H8.57812C6.44569 15.4693 4.71094 17.2042 4.71094 19.3365L4.71108 23.0871C4.71108 23.6697 5.1833 24.1418 5.76577 24.1418C6.34823 24.1418 6.82045 23.6696 6.82045 23.0871L6.82031 19.3367C6.82031 18.3673 7.6088 17.5789 8.57812 17.5789H14.2734V19.6882H9.98438C9.70467 19.6882 9.43636 19.7993 9.23864 19.9972C9.04078 20.1949 8.92969 20.4632 8.92969 20.7429L8.93109 54.4921C8.93109 55.0747 9.40331 55.5468 9.98578 55.5468L62.0156 55.5454C62.2953 55.5454 62.5636 55.4343 62.7615 55.2364C62.9592 55.0387 63.0703 54.7704 63.0703 54.4907L63.0689 20.7415C63.0689 20.1589 62.5967 19.6868 62.0142 19.6868H57.7266V17.5774H63.4205C64.3898 17.5774 65.1783 18.3659 65.1783 19.3353L65.1797 55.8969C65.1797 56.8662 64.3912 57.6547 63.4219 57.6547L8.57953 57.6561C7.6102 57.6561 6.82172 56.8676 6.82172 55.8983L6.82073 27.6004C6.82073 27.0177 6.34852 26.5457 5.76605 26.5457C5.18358 26.5457 4.71136 27.0179 4.71136 27.6004L4.71234 55.8983C4.71234 56.5311 4.86605 57.1284 5.13675 57.6561H3.02344C1.35633 57.6561 0 59.0125 0 60.6796V63.7733C0 65.4406 1.35633 66.7969 3.02344 66.7969H44.9551C45.5378 66.7969 46.0098 66.3248 46.0098 65.7422C46.0098 65.1596 45.5378 64.6875 44.9551 64.6875H3.02344C2.51944 64.6875 2.10938 64.2775 2.10938 63.7735V60.6797C2.10938 60.1757 2.51944 59.7656 3.02344 59.7656H28.8984V60.5067C28.8984 61.9591 30.0801 63.1408 31.5325 63.1408H40.4677C41.92 63.1408 43.1016 61.9593 43.1016 60.5067V59.7656H68.9766C69.4806 59.7656 69.8906 60.1757 69.8906 60.6797V63.7735C69.8906 64.2775 69.4806 64.6875 68.9766 64.6875H49.5598C48.9772 64.6875 48.5051 65.1596 48.5051 65.7422C48.5051 66.3248 48.9772 66.7969 49.5598 66.7969H68.9766C70.6437 66.7969 72 65.4406 72 63.7735V60.6797C72 59.0125 70.6437 57.6561 68.9766 57.6561ZM52.8988 34.717C53.6404 34.4603 54.1388 33.7606 54.1388 32.9759V14.4471H55.6172V38.3902H42.2769L52.8988 34.717ZM19.9706 7.41996L34.9453 12.5985V37.9643L19.9706 32.7858V7.41996ZM16.3828 14.4471H17.8612V32.976C17.8612 33.7607 18.3596 34.4605 19.1015 34.7172L29.7231 38.3904H16.3828V14.4471ZM60.9595 21.7962L60.9609 53.436L11.0403 53.4374L11.0391 21.7976H14.2734V38.6574C14.2734 39.6731 15.0997 40.4996 16.1156 40.4996H55.8844C56.9002 40.4996 57.7266 39.6731 57.7266 38.6574V21.7962H60.9595ZM40.9922 60.5066C40.9922 60.7959 40.7568 61.0313 40.4677 61.0313H31.5325C31.2432 61.0313 31.0078 60.7959 31.0078 60.5066V59.7655H40.9922V60.5066Z",
    fill: "url(#paint0_linear_1303_94681)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.8528 43.5078H22.1465C21.564 43.5078 21.0918 43.9799 21.0918 44.5625C21.0918 45.1451 21.564 45.6172 22.1465 45.6172H49.8528C50.4355 45.6172 50.9075 45.1451 50.9075 44.5625C50.9075 43.9799 50.4353 43.5078 49.8528 43.5078Z",
    fill: "url(#paint1_linear_1303_94681)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.1147 47.9814H22.1465C21.564 47.9814 21.0918 48.4535 21.0918 49.0361C21.0918 49.6187 21.564 50.0908 22.1465 50.0908H40.1147C40.6973 50.0908 41.1694 49.6187 41.1694 49.0361C41.1694 48.4535 40.6972 47.9814 40.1147 47.9814Z",
    fill: "url(#paint2_linear_1303_94681)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1303_94681",
    x1: -5.31409e-7,
    y1: 7.02363,
    x2: 80.3875,
    y2: 51.7075,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0532222,
    stopColor: "#2496C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#046E9B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1303_94681",
    x1: 21.0918,
    y1: 43.5702,
    x2: 22.0354,
    y2: 49.9128,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0532222,
    stopColor: "#2496C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#046E9B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1303_94681",
    x1: 21.0918,
    y1: 48.0438,
    x2: 22.4575,
    y2: 54.225,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0532222,
    stopColor: "#2496C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#046E9B"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1303_94681"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 72,
    height: 72,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCourses);
export default __webpack_public_path__ + "static/media/courses.2673924a6a14852b5de1d5923cb46715.svg";
export { ForwardRef as ReactComponent };